import { GSInfoGroup } from "golfstatus_react_components";
import React from "react";
import "./tournament-reporting-order-item.scss";

import { getDate, getDateTimeOn } from "../../../helpers/Dates";
import { GSButton } from "golfstatus_react_components";
import { moneyWithCommas } from "../../../helpers/RegexHelper";
import { faBan, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { formatPhoneNumber } from "../../../helpers/Utilities";
import { selectCustomerInvoice } from "../../../reducers/settingsSlice";
import { useSelector } from "react-redux";

const CUSTOMER_INVOICE = "customer_invoice";
const VOID = "void";

const TournamentReportingOrderItem = (props) => {
  const {
    invoiceNumber,
    placedAt,
    status,
    paymentType,
    registrationCustomer,
    registrationOrderItems,
    purchaseCost,
    stripeOrder,
    registrationOrderRefunds,
    invoicePaidAt,
    createdAt,
  } = props;

  const customerInvoice = useSelector(selectCustomerInvoice);

  const refunded = () => {
    return registrationOrderRefunds?.length > 0;
  };

  const totalRefundedAmount = registrationOrderRefunds?.reduce(
    (total, refund) => {
      return total + refund?.amount;
    },
    0
  );

  const orderSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width capitalize",
        value: paymentType?.replaceAll?.("_", " "),
      },
      {
        type: "secondary no-wrap full-width",
        value: `${getDateTimeOn(placedAt)}`,
      },
      {
        type: "secondary",
        value: stripeOrder ? `Stripe ID: ${stripeOrder}` : "Online Order",
      },
    ],
  };

  const customerSection = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: `${registrationCustomer?.fullName}`,
      },
      {
        type: "secondary no-wrap full-width",
        value: `${registrationCustomer?.email}`,
      },
      {
        type: "secondary no-wrap full-width",
        value: `${formatPhoneNumber(registrationCustomer?.phone)}`,
      },
    ],
  };

  const invoiceSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: `Customer Invoice`,
      },
      {
        type: "secondary no-wrap full-width",
        value: invoiceNumber ?? ''
      },
      {
        type: "secondary no-wrap full-width",
        value: `${getDateTimeOn(createdAt)}`,
      },
      {
        type: "secondary no-wrap full-width",
        value: `Online Order`,
      },
    ],
  };

  const invoicePaidSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width",
        value: paymentType === CUSTOMER_INVOICE ? "Marked as Paid" : <div>Paid via <span style={{textTransform: "capitalize"}}>{paymentType?.replaceAll?.("_", " ")}</span> </div> ,
      },
      {
        type: "secondary no-wrap full-width",
        value: `${getDate(invoicePaidAt)}`,
      },
    ],
  };

  const invoiceDueSection = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width capitalize",
        value: `Payment Due`,
      },
      {
        type: "secondary no-wrap full-width",
        value: `${getDate(customerInvoice?.dueDate)}`,
      },
    ],
  };

  const packageSection = {
    sectionItems: [
      {
        type: "secondary full-width",
        value: `${registrationOrderItems
          ?.map(
            (roi) =>
              `${roi?.tournamentPackage?.name} ${
                roi?.quantity > 1 ? `(x${roi?.quantity})` : ""
              }`
          )
          .join?.(", ")}`,
      },
    ],
  };

  const customerColumn = {
    fit: "stretch",
    sections: [
      {
        ...customerSection,
      },
    ],
  };

  if (paymentType === CUSTOMER_INVOICE || invoicePaidAt) {
    customerColumn.sections.push(invoiceSection);
    if (status !== VOID) {
      if (invoicePaidAt) {
        customerColumn.sections.push(invoicePaidSection);
      } else {
        customerColumn.sections.push(invoiceDueSection);
      }
    }
  } else {
    customerColumn.sections.push({ ...orderSection });
  }

  customerColumn.sections.push({ ...packageSection });

  const orderColor = () => {
    if (refunded()) {
      return "orange";
    } else if (status === "paid" || status === "sent") {
      return "green";
    }
    return "grey";
  };

  const statusDisplay = () => {
    if (refunded()) {
      return "refunded";
    } else if (status === "cancelled") {
      return "void";
    } else {
      return status;
    }
  };

  const orderIcon = () => {
    if (status === "pending") {
      return faSpinner;
    } else if (status === "declined") {
      return faBan;
    } else {
      return null;
    }
  };

  const statusSection = {
    sectionItems: [
      {
        type: "primary no-wrap full-width flex-end flex-start-mobile",
        value: (
          <GSButton
            type={`${orderColor()} pill secondary`}
            title={statusDisplay()}
            buttonIcon={orderIcon()}
          />
        ),
      },
    ],
  };

  const costSection = {
    sectionItems: [
      {
        type: "primary no-wrap full-width flex-end flex-start-mobile",
        value: moneyWithCommas(purchaseCost),
      },
    ],
  };

  const refundSection = {
    sectionItems: [
      {
        type: "primary no-wrap full-width flex-end flex-start-mobile",
        value: moneyWithCommas(purchaseCost - totalRefundedAmount),
      },
      {
        type: "secondary strike no-wrap full-width flex-end flex-start-mobile",
        value: moneyWithCommas(purchaseCost),
      },
    ],
  };

  const costColumn = {
    sections: [{ ...statusSection }],
  };

  if (status !== "draft") {
    costColumn.sections?.unshift({
      ...(refunded() ? refundSection : costSection),
    });
  }

  const getGroup = () => {
    let group = [{ ...customerColumn }, { ...costColumn }];
    return group;
  };

  return (
    <tournament-reporting-order-item>
      <GSInfoGroup
        listType="mobile-vertical"
        dataGroups={getGroup()}
      ></GSInfoGroup>
    </tournament-reporting-order-item>
  );
};

export default TournamentReportingOrderItem;
